import React from 'react';
import { Input } from 'antd';

let LoginInput = React.forwardRef((props, ref) => {
  return <Input {...props} ref={ref} onChange={props.onChange} />;
});

const loginPhoneMask = Component => {
  return React.forwardRef(({ value, type, mask, onChange, ...rest }, ref) => {
    let handleChange = e => {
      let { value, name } = e.target;
      value = value.trim().replace(/[^\d]/g, '');
      onChange({ ...e, target: { ...e.target, value, name } });
    };

    let format = (value, mask) => {
      let i = 0;
      let lastReplacedIndex = -1;
      if (value !== 'undefined') {
        const filledMask = mask.replace(/#/g, (_, index) => {
          if (i >= value.length) {
            return ' ';
          }
          lastReplacedIndex = index;
          return value[i++];
        });
        return filledMask.substring(0, lastReplacedIndex + 1);
      }
    };

    return (
      <Component
        ref={ref}
        type="text"
        value={format(String(value), mask)}
        onChange={handleChange}
        {...rest}
      />
    );
  });
};

export default loginPhoneMask(LoginInput);
